var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("nav", { attrs: { "aria-label": "breadcrumb" } }, [
        _c("ol", { staticClass: "breadcrumb" }, [
          _c(
            "li",
            { staticClass: "breadcrumb-item" },
            [
              _c("router-link", { attrs: { to: { name: "Home" } } }, [
                _vm._v(_vm._s(_vm.$t("nav.home"))),
              ]),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "li",
            {
              staticClass: "breadcrumb-item active",
              attrs: { "aria-current": "page" },
            },
            [_vm._v("\n        " + _vm._s(_vm.$t("nav.music")) + "\n      ")]
          ),
        ]),
      ]),
      _vm._v(" "),
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { attrs: { sm: "2" } },
            [
              _c(
                "div",
                [
                  _c(
                    "b-input-group",
                    { attrs: { size: "sm" } },
                    [
                      _c(
                        "b-input-group-prepend",
                        [
                          _c(
                            "b-button",
                            {
                              attrs: { variant: "outline-info" },
                              on: {
                                click: function ($event) {
                                  return _vm.newArtist()
                                },
                              },
                            },
                            [
                              _c("font-awesome-icon", {
                                attrs: { icon: ["fas", "user-plus"] },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("b-form-input", {
                        model: {
                          value: _vm.filtArtist,
                          callback: function ($$v) {
                            _vm.filtArtist = $$v
                          },
                          expression: "filtArtist",
                        },
                      }),
                      _vm._v(" "),
                      _c(
                        "b-input-group-append",
                        [
                          _c(
                            "b-button",
                            {
                              on: {
                                click: function ($event) {
                                  return _vm.filterArtist()
                                },
                              },
                            },
                            [
                              _c("font-awesome-icon", {
                                attrs: { icon: ["fas", "search"] },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "b-input-group-append",
                        [
                          _c(
                            "b-button",
                            {
                              attrs: { variant: "danger" },
                              on: { click: _vm.CancelFilter },
                            },
                            [
                              _c("font-awesome-icon", {
                                attrs: { icon: ["fas", "times"] },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _vm._l(_vm.artistsFiltered, function (a) {
                return _c("ArtistCard", {
                  key: a.art_id,
                  attrs: {
                    item: a,
                    selected:
                      _vm.currentArtist &&
                      a.art_id === _vm.currentArtist.art_id,
                  },
                  on: {
                    click: function ($event) {
                      return _vm.SelectArtist(a)
                    },
                  },
                })
              }),
              _vm._v(" "),
              _c(
                "b-modal",
                {
                  attrs: {
                    id: "newArtist",
                    title: "Création d'un Artist",
                    centered: "",
                  },
                  on: {
                    cancel: function ($event) {
                      return _vm.resetNewArtist()
                    },
                    ok: function ($event) {
                      return _vm.createNewArtist()
                    },
                    hide: function ($event) {
                      return _vm.resetNewArtist()
                    },
                  },
                },
                [
                  _c(
                    "b-form-group",
                    {
                      attrs: {
                        label: "Nom",
                        "label-for": "name-input",
                        "invalid-feedback": "Nom est obligatoire",
                      },
                    },
                    [
                      _c("b-form-input", {
                        attrs: {
                          id: "name-input",
                          state: _vm.tempNewArtist.NameIsValidNotExist(
                            _vm.artists
                          ),
                          required: "",
                        },
                        model: {
                          value: _vm.tempNewArtist.art_name,
                          callback: function ($$v) {
                            _vm.$set(_vm.tempNewArtist, "art_name", $$v)
                          },
                          expression: "tempNewArtist.art_name",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "b-col",
            [
              _vm.currentArtist
                ? _c(
                    "div",
                    { staticClass: "mb-3" },
                    [
                      _c(
                        "b-input-group",
                        { attrs: { prepend: "Ajouter un album" } },
                        [
                          _c("b-form-file", {
                            attrs: {
                              placeholder:
                                "Choisir un répertoire ou déposer ici...",
                              "drop-placeholder": "Déposer ici...",
                              directory: true,
                              multiple: "",
                              "browse-text": "Choisir",
                            },
                            model: {
                              value: _vm.newAlbumFolder,
                              callback: function ($$v) {
                                _vm.newAlbumFolder = $$v
                              },
                              expression: "newAlbumFolder",
                            },
                          }),
                          _vm._v(" "),
                          _c(
                            "b-input-group-append",
                            [
                              _c(
                                "b-button",
                                {
                                  attrs: {
                                    disabled: _vm.newAlbumFolder === null,
                                    variant:
                                      _vm.newAlbumFolder !== null
                                        ? "success"
                                        : "",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.extractTracks()
                                    },
                                  },
                                },
                                [_vm._v("Extraire les pistes")]
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "b-input-group-append",
                            [
                              _c(
                                "b-button",
                                {
                                  ref: "btnUndo",
                                  attrs: {
                                    variant:
                                      _vm.newAlbumFolder !== null
                                        ? "danger"
                                        : "secondary",
                                  },
                                  on: {
                                    click: function ($event) {
                                      _vm.newAlbumFolder = null
                                    },
                                  },
                                },
                                [
                                  _c("font-awesome-icon", {
                                    attrs: { icon: ["fas", "times"] },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.currentArtist
                ? _c("b-table", {
                    ref: "tableAlbum",
                    attrs: {
                      items: _vm.currentArtist.albums,
                      fields: _vm.alb_fields,
                      small: "",
                      responsive: "sm",
                      "head-variant": "light",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "cell(alb_id)",
                          fn: function (data) {
                            return [
                              _vm._v(
                                "\n          " +
                                  _vm._s(data.value) +
                                  "\n        "
                              ),
                            ]
                          },
                        },
                        {
                          key: "cell(ass_id)",
                          fn: function (row) {
                            return [
                              _c(
                                "div",
                                { staticClass: "text-left" },
                                [
                                  _c(
                                    "b-form-group",
                                    {
                                      staticClass: "p-0",
                                      attrs: { cols: "1" },
                                    },
                                    [
                                      _c(
                                        "b-input-group",
                                        { attrs: { size: "sm" } },
                                        [
                                          _c("b-input-group-prepend", [
                                            _c("img", {
                                              attrs: {
                                                src: row.item.image,
                                                alt: "Photo Album",
                                                width: "30",
                                                height: "30",
                                              },
                                            }),
                                          ]),
                                          _vm._v(" "),
                                          _vm.IsThisAlbum(row.item)
                                            ? _c("b-form-file", {
                                                attrs: {
                                                  size: "sm",
                                                  accept: "image/*",
                                                  placeholder: "Fichier",
                                                  "browse-text": "...",
                                                },
                                                on: {
                                                  input: function ($event) {
                                                    return _vm.changeFile(
                                                      row.item
                                                    )
                                                  },
                                                },
                                                model: {
                                                  value: row.item.file,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      row.item,
                                                      "file",
                                                      $$v
                                                    )
                                                  },
                                                  expression: "row.item.file",
                                                },
                                              })
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _vm.IsThisAlbum(row.item)
                                            ? _c(
                                                "b-input-group-append",
                                                [
                                                  _c(
                                                    "b-button",
                                                    {
                                                      attrs: {
                                                        variant: "danger",
                                                      },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.CancelEditImage(
                                                            row.item
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _c("font-awesome-icon", {
                                                        attrs: {
                                                          icon: [
                                                            "fas",
                                                            "times",
                                                          ],
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                ],
                                                1
                                              )
                                            : _vm._e(),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ]
                          },
                        },
                        {
                          key: "cell(alb_name)",
                          fn: function (row) {
                            return [
                              _vm.IsThisAlbum(row.item)
                                ? _c(
                                    "div",
                                    [
                                      _c(
                                        "b-form-input",
                                        {
                                          staticClass: "formEdit",
                                          attrs: {
                                            required: "",
                                            state: row.item.NameIsValid(
                                              _vm.currentArtist.albums
                                            ),
                                            placeholder: "Nom de l'album",
                                          },
                                          model: {
                                            value: row.item.alb_name,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                row.item,
                                                "alb_name",
                                                $$v
                                              )
                                            },
                                            expression: "row.item.alb_name",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n              " +
                                              _vm._s(row.item.alb_name) +
                                              "\n            "
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  )
                                : _c("div", [
                                    _vm._v(
                                      "\n            " +
                                        _vm._s(row.item.alb_name) +
                                        "\n          "
                                    ),
                                  ]),
                            ]
                          },
                        },
                        {
                          key: "cell(alb_description)",
                          fn: function (row) {
                            return [
                              _vm.IsThisAlbum(row.item)
                                ? _c(
                                    "div",
                                    [
                                      _c(
                                        "b-form-input",
                                        {
                                          staticClass: "formEdit",
                                          attrs: {
                                            placeholder:
                                              "Description sommaire de l'album",
                                          },
                                          model: {
                                            value: row.item.alb_description,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                row.item,
                                                "alb_description",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "row.item.alb_description",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n              " +
                                              _vm._s(row.item.alb_description) +
                                              "\n            "
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  )
                                : _c("div", [
                                    _vm._v(
                                      "\n          " +
                                        _vm._s(row.item.alb_description) +
                                        "\n          "
                                    ),
                                  ]),
                            ]
                          },
                        },
                        {
                          key: "cell(alb_year)",
                          fn: function (row) {
                            return [
                              _vm.IsThisAlbum(row.item)
                                ? _c(
                                    "div",
                                    [
                                      _c(
                                        "b-form-input",
                                        {
                                          staticClass: "formEdit",
                                          attrs: {
                                            type: "number",
                                            placeholder:
                                              "Année de sortie de l'album",
                                            state: row.item.YearIsValid(),
                                          },
                                          model: {
                                            value: row.item.alb_year,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                row.item,
                                                "alb_year",
                                                $$v
                                              )
                                            },
                                            expression: "row.item.alb_year",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n              " +
                                              _vm._s(row.item.alb_year) +
                                              "\n            "
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  )
                                : _c("div", [
                                    _vm._v(
                                      "\n          " +
                                        _vm._s(row.item.alb_year) +
                                        "\n          "
                                    ),
                                  ]),
                            ]
                          },
                        },
                        {
                          key: "cell(genres)",
                          fn: function (row) {
                            return [
                              _vm.IsThisAlbum(row.item)
                                ? _c(
                                    "div",
                                    [
                                      _c("b-form-select", {
                                        staticClass: "mb-3 formEdit",
                                        attrs: {
                                          placehoder: "Choisir un genre",
                                          options: _vm.genres,
                                          "value-field": "gmus_id",
                                          "text-field": "gmus_label",
                                          "disabled-field": "notEnabled",
                                          multiple: "",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "first",
                                              fn: function () {
                                                return [
                                                  _c(
                                                    "b-form-select-option",
                                                    {
                                                      attrs: {
                                                        value: null,
                                                        disabled: "",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        "-- Choisir un genre --"
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              },
                                              proxy: true,
                                            },
                                          ],
                                          null,
                                          true
                                        ),
                                        model: {
                                          value: row.item.genres,
                                          callback: function ($$v) {
                                            _vm.$set(row.item, "genres", $$v)
                                          },
                                          expression: "row.item.genres",
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                : _c("div", [
                                    _vm._v(
                                      "\n            " +
                                        _vm._s(_vm.GenresName(row.item)) +
                                        "\n          "
                                    ),
                                  ]),
                            ]
                          },
                        },
                        {
                          key: "cell(details)",
                          fn: function (row) {
                            return [
                              _c(
                                "b-button",
                                {
                                  attrs: {
                                    disabled: !(
                                      _vm.editAlbum === null ||
                                      _vm.IsThisAlbum(row.item)
                                    ),
                                    size: "sm",
                                    variant: _vm.colorSaveAlbum(row.item),
                                  },
                                  on: {
                                    click: function ($event) {
                                      _vm.IsThisAlbum(row.item)
                                        ? _vm.submitAlbum(row.item)
                                        : _vm.onEdit(row.item)
                                    },
                                  },
                                },
                                [
                                  _vm.IsThisAlbum(row.item)
                                    ? _c("font-awesome-icon", {
                                        attrs: { icon: ["fas", "save"] },
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  !_vm.IsThisAlbum(row.item)
                                    ? _c("font-awesome-icon", {
                                        attrs: { icon: ["fas", "edit"] },
                                      })
                                    : _vm._e(),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _vm.IsThisAlbum(row.item)
                                ? _c(
                                    "b-button",
                                    {
                                      staticClass: "editbtn",
                                      attrs: { size: "sm" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.UndoAlbum()
                                        },
                                      },
                                    },
                                    [
                                      _c("font-awesome-icon", {
                                        attrs: { icon: ["fas", "undo"] },
                                      }),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "b-button",
                                {
                                  staticClass: "editbtn",
                                  attrs: { size: "sm" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.ShowListTracks(row)
                                    },
                                  },
                                },
                                [
                                  _c("font-awesome-icon", {
                                    attrs: {
                                      icon: [
                                        "fas",
                                        row.detailsShowing
                                          ? "eye-slash"
                                          : "eye",
                                      ],
                                    },
                                  }),
                                  _vm._v(" Pistes\n          "),
                                ],
                                1
                              ),
                            ]
                          },
                        },
                        {
                          key: "row-details",
                          fn: function (row) {
                            return [
                              _c(
                                "b-card",
                                { attrs: { "border-variant": "success" } },
                                [
                                  _c("b-table", {
                                    ref: "tableTrack",
                                    attrs: {
                                      items: row.item.tracks,
                                      fields: _vm.trk_fields,
                                      small: "",
                                      responsive: "sm",
                                      "head-variant": "light",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "cell(trk_id)",
                                          fn: function (data) {
                                            return [
                                              _vm._v(
                                                "\n                " +
                                                  _vm._s(data.value) +
                                                  "\n              "
                                              ),
                                            ]
                                          },
                                        },
                                        {
                                          key: "cell(trk_number)",
                                          fn: function (row) {
                                            return [
                                              _vm.IsThisTrack(row.item)
                                                ? _c(
                                                    "div",
                                                    [
                                                      _c(
                                                        "b-form-input",
                                                        {
                                                          staticClass:
                                                            "formEdit",
                                                          attrs: {
                                                            placeholder:
                                                              "N° de la piste",
                                                            required: "",
                                                          },
                                                          model: {
                                                            value:
                                                              row.item
                                                                .trk_number,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                row.item,
                                                                "trk_number",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "row.item.trk_number",
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                    " +
                                                              _vm._s(
                                                                row.item
                                                                  .trk_number
                                                              ) +
                                                              "\n                  "
                                                          ),
                                                        ]
                                                      ),
                                                    ],
                                                    1
                                                  )
                                                : _c("div", [
                                                    _vm._v(
                                                      "\n                " +
                                                        _vm._s(
                                                          row.item.trk_number
                                                        ) +
                                                        "\n                "
                                                    ),
                                                  ]),
                                            ]
                                          },
                                        },
                                        {
                                          key: "cell(trk_name)",
                                          fn: function (row) {
                                            return [
                                              _vm.IsThisTrack(row.item)
                                                ? _c(
                                                    "div",
                                                    [
                                                      _c(
                                                        "b-form-input",
                                                        {
                                                          staticClass:
                                                            "formEdit",
                                                          attrs: {
                                                            required: "",
                                                            placeholder:
                                                              "Nom de la piste",
                                                            state:
                                                              row.item.NameIsValid(),
                                                          },
                                                          model: {
                                                            value:
                                                              row.item.trk_name,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                row.item,
                                                                "trk_name",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "row.item.trk_name",
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                    " +
                                                              _vm._s(
                                                                row.item
                                                                  .trk_name
                                                              ) +
                                                              "\n                  "
                                                          ),
                                                        ]
                                                      ),
                                                    ],
                                                    1
                                                  )
                                                : _c("div", [
                                                    _vm._v(
                                                      "\n                  " +
                                                        _vm._s(
                                                          row.item.trk_name
                                                        ) +
                                                        "\n                "
                                                    ),
                                                  ]),
                                            ]
                                          },
                                        },
                                        {
                                          key: "cell(trk_description)",
                                          fn: function (row) {
                                            return [
                                              _vm.IsThisTrack(row.item)
                                                ? _c(
                                                    "div",
                                                    [
                                                      _c(
                                                        "b-form-input",
                                                        {
                                                          staticClass:
                                                            "formEdit",
                                                          attrs: {
                                                            placeholder:
                                                              "Description sommaire de la piste",
                                                          },
                                                          model: {
                                                            value:
                                                              row.item
                                                                .trk_description,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                row.item,
                                                                "trk_description",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "row.item.trk_description",
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                    " +
                                                              _vm._s(
                                                                row.item
                                                                  .trk_description
                                                              ) +
                                                              "\n                  "
                                                          ),
                                                        ]
                                                      ),
                                                    ],
                                                    1
                                                  )
                                                : _c("div", [
                                                    _vm._v(
                                                      "\n                  " +
                                                        _vm._s(
                                                          row.item
                                                            .trk_description
                                                        ) +
                                                        "\n                "
                                                    ),
                                                  ]),
                                            ]
                                          },
                                        },
                                        {
                                          key: "cell(trk_year)",
                                          fn: function (row) {
                                            return [
                                              _vm.IsThisTrack(row.item)
                                                ? _c(
                                                    "div",
                                                    [
                                                      _c(
                                                        "b-form-input",
                                                        {
                                                          staticClass:
                                                            "formEdit",
                                                          attrs: {
                                                            type: "number",
                                                            placeholder:
                                                              "Année de sortie de la piste",
                                                            state:
                                                              row.item.YearIsValid(),
                                                          },
                                                          model: {
                                                            value:
                                                              row.item.trk_year,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                row.item,
                                                                "trk_year",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "row.item.trk_year",
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            "\n                    " +
                                                              _vm._s(
                                                                row.item
                                                                  .trk_year
                                                              ) +
                                                              "\n                  "
                                                          ),
                                                        ]
                                                      ),
                                                    ],
                                                    1
                                                  )
                                                : _c("div", [
                                                    _vm._v(
                                                      "\n                " +
                                                        _vm._s(
                                                          row.item.trk_year
                                                        ) +
                                                        "\n                "
                                                    ),
                                                  ]),
                                            ]
                                          },
                                        },
                                        {
                                          key: "cell(trk_duration)",
                                          fn: function (row) {
                                            return [
                                              _vm.IsThisTrack(row.item)
                                                ? _c(
                                                    "div",
                                                    [
                                                      _c(
                                                        "b-input-group",
                                                        [
                                                          _c("b-form-input", {
                                                            staticClass:
                                                              "formEdit",
                                                            attrs: {
                                                              size: "sm",
                                                              type: "text",
                                                              placeholder:
                                                                "hh:mm:ss",
                                                            },
                                                            model: {
                                                              value:
                                                                row.item
                                                                  .trk_duration,
                                                              callback:
                                                                function ($$v) {
                                                                  _vm.$set(
                                                                    row.item,
                                                                    "trk_duration",
                                                                    $$v
                                                                  )
                                                                },
                                                              expression:
                                                                "row.item.trk_duration",
                                                            },
                                                          }),
                                                          _vm._v(" "),
                                                          _c(
                                                            "b-input-group-append",
                                                            [
                                                              _c(
                                                                "b-form-timepicker",
                                                                _vm._b(
                                                                  {
                                                                    staticClass:
                                                                      "formEdit",
                                                                    attrs: {
                                                                      "button-variant":
                                                                        "secondary",
                                                                      size: "sm",
                                                                      "button-only":
                                                                        "",
                                                                      right: "",
                                                                      "show-seconds":
                                                                        "",
                                                                      locale:
                                                                        "fr",
                                                                      state:
                                                                        row.item.DurationIsValid(),
                                                                      "reset-button":
                                                                        "",
                                                                      reset_value:
                                                                        "00:00:00",
                                                                    },
                                                                    model: {
                                                                      value:
                                                                        row.item
                                                                          .trk_duration,
                                                                      callback:
                                                                        function (
                                                                          $$v
                                                                        ) {
                                                                          _vm.$set(
                                                                            row.item,
                                                                            "trk_duration",
                                                                            $$v
                                                                          )
                                                                        },
                                                                      expression:
                                                                        "row.item.trk_duration",
                                                                    },
                                                                  },
                                                                  "b-form-timepicker",
                                                                  _vm.timeLabel,
                                                                  false
                                                                )
                                                              ),
                                                            ],
                                                            1
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                    ],
                                                    1
                                                  )
                                                : _c("div", [
                                                    _vm._v(
                                                      "\n                " +
                                                        _vm._s(
                                                          row.item.trk_duration
                                                        ) +
                                                        "\n                "
                                                    ),
                                                  ]),
                                            ]
                                          },
                                        },
                                        {
                                          key: "cell(trk_gmus_id)",
                                          fn: function (row) {
                                            return [
                                              _vm.IsThisTrack(row.item)
                                                ? _c(
                                                    "div",
                                                    [
                                                      _c("b-form-select", {
                                                        staticClass:
                                                          "mb-3 formEdit",
                                                        attrs: {
                                                          options: _vm.genres,
                                                          "value-field":
                                                            "gmus_id",
                                                          "text-field":
                                                            "gmus_label",
                                                          "disabled-field":
                                                            "notEnabled",
                                                        },
                                                        scopedSlots: _vm._u(
                                                          [
                                                            {
                                                              key: "first",
                                                              fn: function () {
                                                                return [
                                                                  _c(
                                                                    "b-form-select-option",
                                                                    {
                                                                      attrs: {
                                                                        value:
                                                                          null,
                                                                        disabled:
                                                                          "",
                                                                      },
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "-- Choisir un genre --"
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ]
                                                              },
                                                              proxy: true,
                                                            },
                                                          ],
                                                          null,
                                                          true
                                                        ),
                                                        model: {
                                                          value:
                                                            row.item
                                                              .trk_gmus_id,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              row.item,
                                                              "trk_gmus_id",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "row.item.trk_gmus_id",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  )
                                                : _c("div", [
                                                    _vm._v(
                                                      "\n                " +
                                                        _vm._s(
                                                          _vm.GenreName(
                                                            row.item.trk_gmus_id
                                                          )
                                                        ) +
                                                        "\n                "
                                                    ),
                                                  ]),
                                            ]
                                          },
                                        },
                                        {
                                          key: "cell(details)",
                                          fn: function (row) {
                                            return [
                                              _c(
                                                "div",
                                                { staticClass: "details" },
                                                [
                                                  _c(
                                                    "b-button",
                                                    {
                                                      attrs: {
                                                        disabled: !(
                                                          _vm.editTrack ===
                                                            null ||
                                                          _vm.IsThisTrack(
                                                            row.item
                                                          )
                                                        ),
                                                        size: "sm",
                                                        variant:
                                                          _vm.colorSaveTrack(
                                                            row.item
                                                          ),
                                                      },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          _vm.IsThisTrack(
                                                            row.item
                                                          )
                                                            ? _vm.submitTrack(
                                                                row.item
                                                              )
                                                            : _vm.onEditTrk(
                                                                row.item
                                                              )
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _vm.IsThisTrack(row.item)
                                                        ? _c(
                                                            "font-awesome-icon",
                                                            {
                                                              attrs: {
                                                                icon: [
                                                                  "fas",
                                                                  "save",
                                                                ],
                                                              },
                                                            }
                                                          )
                                                        : _vm._e(),
                                                      _vm._v(" "),
                                                      !_vm.IsThisTrack(row.item)
                                                        ? _c(
                                                            "font-awesome-icon",
                                                            {
                                                              attrs: {
                                                                icon: [
                                                                  "fas",
                                                                  "edit",
                                                                ],
                                                              },
                                                            }
                                                          )
                                                        : _vm._e(),
                                                    ],
                                                    1
                                                  ),
                                                  _vm._v(" "),
                                                  _vm.IsThisTrack(row.item)
                                                    ? _c(
                                                        "b-button",
                                                        {
                                                          staticClass:
                                                            "editbtn",
                                                          attrs: { size: "sm" },
                                                          on: {
                                                            click: function (
                                                              $event
                                                            ) {
                                                              return _vm.UndoTrack()
                                                            },
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "font-awesome-icon",
                                                            {
                                                              attrs: {
                                                                icon: [
                                                                  "fas",
                                                                  "undo",
                                                                ],
                                                              },
                                                            }
                                                          ),
                                                        ],
                                                        1
                                                      )
                                                    : _vm._e(),
                                                ],
                                                1
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  }),
                                ],
                                1
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      65594100
                    ),
                  })
                : _vm._e(),
              _vm._v(" "),
              _c(
                "b-modal",
                {
                  attrs: {
                    id: _vm.infoModal.id,
                    title: _vm.infoModal.title,
                    centered: "",
                  },
                  on: {
                    cancel: _vm.resetInfoModal,
                    hide: _vm.resetInfoModal,
                    ok: _vm.okInfoModal,
                  },
                },
                [_c("pre", [_vm._v(_vm._s(_vm.infoModal.content))])]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }